import React, {Component} from 'react'
import Navbar from '../App/Navbar';
import Footer from '../App/Footer';
import API_Root from '../Constants/API_Root';
import { Link } from 'react-router-dom';
import { auth } from '../Authentication/firebase/firebase';
import PricingComponent from './PricingComponent';
import { authFetch } from '../Authentication/authService';

class Pricing extends Component {
    state = {
        userEmail: null,
        subscriptionType: '',
        paymentMode: '',
    };

    componentDidMount() {
        auth.onAuthStateChanged(user => {
            if (user) {
              this.setState({
                userEmail: user.email,
              });
            } else {
              this.setState({
                userEmail: null,
              });
            }
        });
        
    }
    componentDidUpdate() {
        console.log(this.state.userEmail)
    }
    handleCheckoutClick = async (subscriptionType, paymentMode) => {
        if (this.state.userEmail === null) {
            // Redirect to the /login page
            window.location.href = '/login';
            return; // Stop the execution of this function
        }
        this.setState({ subscriptionType, paymentMode });
        try {
            const response = await authFetch(API_Root + "subscription/create-checkout-session", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: this.state.userEmail,
                    subscriptionType: subscriptionType,
                    paymentMode: paymentMode,
                }),
            });
    
            const data = await response.json();
    
            if (response.ok) {
                // Redirect to Stripe checkout URL
                //console.log('Stripe URL:', data.url); // Confirm the URL is correctly returned
                //console.log('Session ID:', data.sessionId); // Optional: log session ID for debugging
                localStorage.setItem('stripeSessionId', data.sessionId)
                window.location.href = data.url; // Use the correct property
            } else {
                // Handle errors, e.g., show a message to the user
                console.error('Failed to create checkout session:', data.error);
            }
        } catch (error) {
            console.error('Error:', error);
            // Handle errors, e.g., show a message to the user
        }
    };
    
    render() {
        return (
            <div className='faq-grid-layout'>
               <Navbar />
               <div className='top-spacer' />
               <div className='banner'>
                    <div className='banner-container'>
                        <h1>Reclaim your time with myESRA™</h1>
                        <p></p>
                    </div>
               </div>
               <div className='mainsection'>
                    <div className='pricing-container'>
                        <PricingComponent handleCheckoutClick={this.handleCheckoutClick} />
                    </div>
               </div>
               <Footer />
            </div>
        )
    }
}

export default Pricing